import ManualOrderConsigneeDTO from "@/dto/manualOrder/ManualOrderConsigneeDTO";
import { deleteConsignee } from "@/services/api/manualOrder";
import { useRequest } from "ahooks";
import { Button, message } from "antd";
import React from "react";

interface DeleteConsigneeButtonProps {
    value: ManualOrderConsigneeDTO;

    shopId: number;

    onSuccess?(data: ManualOrderConsigneeDTO): void;
}

const DeleteConsigneeButton: React.FC<DeleteConsigneeButtonProps> = function (props) {
    const { value, shopId, onSuccess } = props;
    const { runAsync, loading } = useRequest(deleteConsignee, { manual: true });

    async function handleDelete() {
        const result = await runAsync({ shopId, consigneeIds: [value?.id] });

        if (!result) {
            return;
        }

        message.success("删除收货人成功");

        onSuccess?.(value);
    }

    return (
        <Button type="link" size="small" className="mr10" loading={loading} onClick={handleDelete}>
            删除
        </Button>
    );
};

export default DeleteConsigneeButton;
